import { apiClient } from './client'

// ---- QW#2: Ranking vehículos ----

export interface RankingVehiculoItem {
  vehiculo: {
    id: string
    codigo: string
    tipoMaquina: { nombre: string; consumoLitrosHoraEsperado: number }
  }
  totalLitros: number
  totalCostoBs: number
  horasTrabajadas: number
  costoPorHoraBs: number
  litrosPorHora: number
  vsEsperadoPct: number
}

export interface RankingVehiculosResponse {
  items: RankingVehiculoItem[]
}

// ---- existing ----

export interface RankingOperador {
  posicion: number
  operadorId: string
  nombre: string
  litros: number
  cargas: number
  outliers: number
  porcentajeOutlier: number
  montoBob: number
}

export interface ResumenMes {
  totalLitros: number
  montoBob: number
  totalCargas: number
  outlierPorcentaje: number
}

export interface RankingResponse {
  mes: string
  items: RankingOperador[]
}

export interface ResumenResponse {
  mes: string
  resumen: ResumenMes
}

export const reportesApi = {
  getRankingOperadores: (mes?: string) =>
    apiClient
      .get<RankingResponse>('/reportes/ranking-operadores', { params: mes ? { mes } : {} })
      .then((r) => r.data),

  getResumen: (mes?: string) =>
    apiClient
      .get<ResumenResponse>('/reportes/resumen', { params: mes ? { mes } : {} })
      .then((r) => r.data),

  rankingVehiculos: (desde?: string, hasta?: string) =>
    apiClient
      .get<RankingVehiculosResponse>('/reportes/ranking-vehiculos', {
        params: { ...(desde && { desde }), ...(hasta && { hasta }) },
      })
      .then((r) => r.data),
}
